import { render, staticRenderFns } from "./OccurencesAdd.vue?vue&type=template&id=4f8ab17c&scoped=true&"
import script from "./OccurencesAdd.vue?vue&type=script&lang=js&"
export * from "./OccurencesAdd.vue?vue&type=script&lang=js&"
import style0 from "./OccurencesAdd.vue?vue&type=style&index=0&id=4f8ab17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ab17c",
  null
  
)

export default component.exports